import { create } from 'zustand';

export const useServerClock = create((set) => ({
  offsetMs: 0,
  sync: (serverNow) => {
    const serverMs = Date.parse(serverNow);
    if (!Number.isNaN(serverMs)) {
      set({ offsetMs: serverMs - Date.now() });
    }
  },
}));

export function serverNow() {
  return Date.now() + useServerClock.getState().offsetMs;
}
